import React from "react";
import { X } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

/**
 * A simple multi-select rendered as chips with a Select dropdown to add more.
 * options: [{ id, label }]
 * value: string[] of ids
 */
export default function MultiSelectChips({
  value = [],
  options = [],
  onChange,
  placeholder = "Add…",
  testId,
}) {
  const remaining = options.filter((o) => !value.includes(o.id));
  return (
    <div className="space-y-1.5">
      <div className="flex flex-wrap gap-1.5 min-h-[32px]">
        {value.length === 0 ? (
          <span className="text-[12px] text-zinc-400 self-center">No links yet</span>
        ) : (
          value.map((id) => {
            const o = options.find((x) => x.id === id);
            return (
              <span
                key={id}
                className="inline-flex items-center gap-1 text-[12px] border hairline rounded px-1.5 py-0.5 bg-zinc-50"
              >
                {o?.label || id}
                <button
                  onClick={() => onChange(value.filter((x) => x !== id))}
                  className="text-zinc-400 hover:text-rose-600"
                  data-testid={`${testId}-remove-${id}`}
                >
                  <X size={11} />
                </button>
              </span>
            );
          })
        )}
      </div>
      {remaining.length > 0 && (
        <Select value="" onValueChange={(v) => v && onChange([...value, v])}>
          <SelectTrigger className="h-8" data-testid={`${testId}-add`}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {remaining.map((o) => (
              <SelectItem key={o.id} value={o.id}>
                {o.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
